<!--  -->
<template>
    <div>
        <input :value="_text"
               placeholder="请选择"
               readonly
               type="text"
               @click="handlerShow"
        />
        <div v-if="visible" class="resume-experience" @click.self="handleCancelClick">
            <div class="resume-experience-content">
                <div class="resume-experience-header">
                    <button class="resume-experience-cancel" @click="handleCancelClick">取消</button>
                    <span class="resume-experience-header-title">选择您的{{ label }}</span>
                    <button class="resume-experience-confirm" @click="handleConfirmClick">确定</button>
                </div>
                <Select
                    :selected-index="selectedIndex"
                    :show="true"
                    :data-list="scope"
                    class="my-select"
                    @on-scrollend="handleScrollEnd"
                />
            </div>
        </div>
    </div>
</template>
<script>

import Select from '@/components/Select';

export default {
    components: {Select},
    props: {
        scope: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: [Number, String],
            default: ''
        }
    },
    data() {
        return {
            selectedIndex: 0,
            visible: false,
            currentValue: ''
        };
    },
    computed: {
        _text() {
            return this.scope.find((i) => i.value === this.value)?.text;
        }
    },
    methods: {
        handlerShow() {
            this.visible = true;
            this.currentValue = this.value;
            this.selectedIndex = Math.max(this.scope.findIndex(((e) => e.value === this.currentValue)), 0);
        },
        handleScrollEnd(item, index) {
            this.currentValue = item.value;
            this.selectedIndex = index;
        },
        handleConfirmClick() {
            this.$emit('input', this.currentValue);
            this.visible = false;
        },
        handleCancelClick() {
            this.$emit('cancel');
            this.visible = false;
        }
    }
};
</script>
<style scoped>
.my-select{
    height: 196px;
}
</style>
